<template>
  <div class="unit">

    <div class="tile is-ancestor">
      <div class="tile is-vertical is-16">
        <div class="tile">
          <div class="tile is-parent">
            <article class="tile is-child notification is-primary">
              <p class="title">Einheiten</p>
              <p class="subtitle">{{ title }}</p>
            </article>
          </div>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child">
            <b-field label="ID" :hidden="isNew">
              <b-input v-model="data.id" disabled="disabled"></b-input>
            </b-field>

            <b-field label="Name">
              <b-input v-model="data.name"></b-input>
            </b-field>

            <b-field label="Einheitensymbol">
              <b-input v-model="data.symbol"></b-input>
            </b-field>

            <b-field label="Gruppe">
              <b-field>
                <b-radio-button v-model="data.group"
                                native-value=""
                                type="is-danger is-light is-outlined">
                  <b-icon icon="close"></b-icon>
                  <span>Keine</span>
                </b-radio-button>

                <b-radio-button v-model="data.group"
                                native-value="length"
                                type="is-primary is-light is-outlined">
                  <b-icon icon="ruler"></b-icon>
                  <span>Länge</span>
                </b-radio-button>

                <b-radio-button v-model="data.group"
                                native-value="area"
                                type="is-primary is-light is-outlined">
                  <b-icon icon="square"></b-icon>
                  <span>Fläche</span>
                </b-radio-button>

                <b-radio-button v-model="data.group"
                                native-value="volume"
                                type="is-primary is-light is-outlined">
                  <b-icon icon="cube"></b-icon>
                  <span>Volumen</span>
                </b-radio-button>

                <b-radio-button v-model="data.group"
                                native-value="weight"
                                type="is-primary is-light is-outlined">
                  <b-icon icon="scale"></b-icon>
                  <span>Gewicht</span>
                </b-radio-button>

                <b-radio-button v-model="data.group"
                                native-value="time"
                                type="is-primary is-light is-outlined">
                  <b-icon icon="clock"></b-icon>
                  <span>Zeit</span>
                </b-radio-button>

                <b-radio-button v-model="data.group"
                                native-value="package"
                                type="is-primary is-light is-outlined">
                  <b-icon icon="package-variant"></b-icon>
                  <span>Verpackungsformen / Gebinde</span>
                </b-radio-button>

              </b-field>
            </b-field>
          </article>
        </div>

        <div class="tile is-parent">
          <article class="tile is-child">
            <div class="field is-grouped">
              <div class="control">
                <router-link class="" to="/units">
                  <button class="button is-secondary">Zurück</button>
                </router-link>
              </div>
              <div class="control" :hidden="isNew">
                <button class="button is-link" @click="update">Speichern</button>
              </div>
              <div class="control" :hidden="!isNew">
                <button class="button is-link" @click="create">Erstellen</button>
              </div>
            </div>
          </article>
        </div>


      </div>
    </div>
  </div>
</template>

<script>

import { ToastProgrammatic as Toast, DialogProgrammatic as Dialog } from 'buefy'
import apiservice from "@/services/apiservice";


export default {
  name: 'Unit',
  props: {
  },
  data() {
            return {
              data: {},
              isNew: null
            }
  },
  computed: {
    title() {
      if (this.isNew){
        return "Neu"
      } else {
        return this.data.name
      }
    }
  },
  components: {

  },
  methods: {
    fetchData: function() {
      apiservice()
          .get('units/' + this.$route.params.id)
          .then(response => (this.data = response.data.data))
          .catch(function (error) {
            Dialog.alert({
              title: 'Fehler',
              message: 'Ein Fehler ist beim Abrufen der Daten aufgetreten.',
              type: 'is-danger',
              hasIcon: true,
              icon: 'times-circle',
              iconPack: 'fa',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
            console.log(error);
          });
    },
    update: function() {
      let self = this
      apiservice()
          .post('units/', this.data)
          .then(function (response) {
              Toast.open({
                message: 'Einheit erfolgreich geändert.',
                position: 'is-bottom',
                type: 'is-success'
              })
              console.log(response);
            self.$router.push("/units");
            })
            .catch(function (error) {
              Dialog.alert({
                title: 'Fehler',
                message: 'Ein Fehler ist aufgetreten: ' + error,
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
              console.log(error);
            });
    },
    create: function() {
      this.data.id = "new"
      let self = this

      apiservice().post('units/', this.data)
          .then(function (response) {
            Toast.open({
              message: 'Einheit erfolgreich hinzugefügt',
              position: 'is-bottom',
              type: 'is-success'
            })
            console.log(response);
            self.$router.push("/units");
          })
          .catch(function (error) {
            Dialog.alert({
                    title: 'Fehler',
                    message: 'Ein Fehler ist aufgetreten: ' + error,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                  })
            console.log(error);
          });
    }
  },
  beforeMount() {
    if (this.$route.params.id == "new") {
      this.isNew = true
    } else {
      this.isNew = false
      this.fetchData()
    }

    //this.fetchData();

    // if (this.isNew) {
    //
    // } else {
    //
    // }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
